import { useAppStore } from "../../stores/RootStore";
import { useFetch } from "../useFetch";
import { useEffect } from "react";
import {  Person } from "../../types/types";

export const useRefreshPersons = () => {
  const setPersons = useAppStore((store) => store.setPersons);

  const [{ response: personsData }, doFetchPersons] = useFetch(`/directories/personnels`);

  useEffect(() => {
    let persons = personsData?.data as unknown as Person[];
    if (persons) {
      setPersons(persons);
    }
  }, [personsData]);

  return doFetchPersons;
};
